import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#095CAA' } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M3.731 4.097a.75.75 0 01.75.75v3.75h3.75a.75.75 0 110 1.5h-4.5a.75.75 0 01-.75-.75v-4.5a.75.75 0 01.75-.75z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M10.996 3.173a9 9 0 013.889 17.571.75.75 0 11-.355-1.457A7.502 7.502 0 0020.255 12 7.5 7.5 0 007.449 6.699L4.26 9.879A.75.75 0 113.2 8.816l3.187-3.177a9 9 0 014.608-2.466z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M11.124 13.742a.75.75 0 010 1.06L7.187 18.74a.75.75 0 01-1.061 0l-1.969-1.968a.75.75 0 111.06-1.061l1.44 1.438 3.406-3.407a.75.75 0 011.061 0z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Icon;
